module.exports = __webpack_public_path__ + "img/Avo_Toast_Spread.99992a88.jpg";